import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ComplainModalContainer.css';

export const ComplainModalLoader = () => (
  <div className={styles['loader']}>
    <Spinner size={40} />
  </div>
);
